module.exports = require("@splunk/visualizations-shared/style");